/**
 * Matches a given mediaquery type.
 *
 * Examples:
 * <pre>if (S.mq('tablet').matches) { ... }</pre>
 * <pre>S.mq('tablet').addListener(function (mq) {
 *      if (mq.matches) {
 *          alert('browser resize, tablet now matches!');
 *      }
 *      else {
 *          alert('browser resize, tablet does not match!');
 *      }
 * });</pre>
 *
 * @param {string} type
 * @param {boolean} [ifUnsupported]
 * @returns {MediaQueryList}
 */
S.mq = function (type, ifUnsupported = false)
{
    let result;

    if (S.breakpoints[type])
    {
        if (window.matchMedia)
        {
            // turns "#{em(768px)}" into "48em"
            const media = S.breakpoints[type].replace(/#{em\((\d+)px\)}/g, function (match, p1)
            {
                return (p1 / 16) + 'em';
            });

            result = window.matchMedia(media);
        }
        else
        {
            // fallback for <= IE9 etc.
            result = {
                matches: ifUnsupported,
                addListener() {},
                removeListener() {},
            };
        }
    }
    else
    {
        console.error('Unknown breakpoint ' + type);
    }

    return result;
};

S.breakpoints = {
    tablet: 'only screen and (min-width: #{em(768px)})',
    desktop: 'print, only screen and (min-width: #{em(1024px)})',
    print: 'print',
};
